import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactanosService {

  constructor(private http: HttpClient) { }

  enviarMailContactanos(nombre:string,mail:string,mensaje:string):Observable<any>{
    const params = new HttpParams()
      .set('funcion', 'enviarMailContactanos')
      .set("nombre",nombre)
      .set("mail",mail)
      .set("mensaje",mensaje)
    ;
    return this.http.get(`${environment.url.gestionSoporte}`, { params });
  }

  enviarMailPresupuesto(nombre:string,mail:string,direccion:string,telefono:string,mensaje:string,file:any):Observable<any>{
    const formData = new FormData();
    formData.set('documento',file);
    const params = new HttpParams()
      .set('funcion', 'enviarMailPresupuesto')
      .set("nombre",nombre)
      .set("mail",mail)
      .set("direccion",direccion)
      .set("telefono",telefono)
      .set("mensaje",mensaje)
    ;
    return this.http.post(`${environment.url.gestionSoporte}`, formData,{ params });
  }
}
